<template>
    <div class="w-full flex flex-col px-2xl py-xl border border-neutral-light">
        <div class="flex w-full items-center">
            <div class="flex">
                <checkbox-input
                    v-model="localSelectedTvPackages"
                    :value="value"
                >
                    <img
                        v-tooltip="tvPackage.name"
                        :src="tvPackage.image"
                        :alt="tvPackage.name"
                        style="height: 40px;"
                    >
                    <div class="ml-xl">
                        <div class="text-helper">{{ tvPackage.name }}</div>
                        <span class="font-semibold">{{ format_sek_per_month(tvPackage.monthly_price) }}</span>
                    </div>
                </checkbox-input>
            </div>

            <a
                class="ml-auto flex items-center mt-xl lg:relative lg:mt-0 text-neutral-darker read-more"
                :class="{ 'is-active' : toggled }"
                tabindex="0"
                @click="toggle"
                @keydown.enter="toggle"
            >
                <font-awesome-icon icon="chevron-down" class="chevron text-sm lg:text-lg" />
            </a>
        </div>
        <div v-if="toggled" class="mt-xl">
            <tv-channel-list
                :tv-package="tvPackage"
            />
        </div>
    </div>
</template>
<script>
    import TvChannelList from '../../../Tv/Partials/TvChannelList';

    export default {
        components: {
            TvChannelList,
        },
        model: {
            prop: 'checked',
            event: 'input',
        },
        props: {
            tvPackage: {
                type: Object,
                required: true,
            },
            checked: {
                required: false,
                type: [Boolean, Array],
                default: false,
            },
        },
        data() {
            return {
                toggled: false,
            };
        },
        computed: {
            value() {
                return this.tvPackage.article_id;
            },
            localSelectedTvPackages: {
                get() {
                    return this.checked;
                },
                set(localState) {
                    this.$emit('input', localState);
                },
            },
        },
        methods: {
            toggle() {
                this.toggled = ! this.toggled;
            },
        },
    };
</script>